import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Dialog from '~/components/Dialog'
import { SelectedContent, SelectedWrapper } from '../style'
import { Icon, Input } from 'semantic-ui-react'

interface Props {
  isDialogOpen: boolean
  handleClose: () => void
  districts: any[]
  remove: (index: number) => void
}

const ShowMoreDialog:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isDialogOpen, handleClose, remove } = props

  const [districts, setDistricts] = useState(props.districts)
  const [search, setSearch] = useState('')

  useEffect(() => {
    if(isDialogOpen) {
      setDistricts(props.districts)
    } else {
      setDistricts([])
    }
  }, [isDialogOpen, props.districts])

  useEffect(() => {
    if(search !== '') {
      const newDistricts = props.districts.filter(district => district?.name?.toLowerCase()?.includes(search.toLowerCase()))
      setDistricts(newDistricts)
    } else {
      setDistricts(props.districts)
    }
  }, [search])

  function renderDistricts() {
    return districts?.map((district, index) => {
      return <div key={district.id} style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
        <SelectedContent>
          <div style={{ display: 'flex' }}>
            <div
              className='title'
            >{`${index + 1}. ${district['name']}`}
            </div>
          </div>
        </SelectedContent>
        <Icon
          name='trash'
          onClick={() => remove(index)}
          color='red'
          style={{ cursor: 'pointer' }}
        />
      </div>
    })
  }

  return <Dialog
    isDialogOpen={isDialogOpen}
    noScrollingContent={false}
    textHeader={t('Selected districts')}
    textClose={t('Close')}
    textContent={<div>
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search districts')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
      <SelectedWrapper>
        {renderDistricts()}
      </SelectedWrapper>
    </div>}
    handleClose={() => handleClose()}
  />
}
export default ShowMoreDialog